import { Metamodel } from 'app/model/base/model';

import { DataFlowSource } from './dataflow-source';
import { InputConfig } from './input-config';

@Metamodel.model({
    name: 'input',
    display: [stringResources.DataFlowInputTransformationLabel, stringResources.DataFlowInputTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class InputTransformation extends DataFlowSource {
    public order: number = 1;

    public skipDatasetValidation = true;

    public debugData?: InputConfig[];

    protected getGeneratedDescription(): string {
        return stringResources.InputTransformationDescription;
    }
}
